module.exports = __webpack_public_path__ + "img/LOGO.8adb0004.png";